import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function LearnFees() {
  const [fees, setFees] = useState(null);

  useEffect(() => {
    api.get('/api/config/fees')
      .then(res => setFees(res.data))
      .catch(() => setFees(null));
  }, []);

  const fmt = (val) => {
    const n = parseFloat(val || '0');
    return n === 0 ? 'Free' : `$${n.toFixed(2)} USDC`;
  };

  return (
    <div className="fees-page">
      <h2>Finema Fees</h2>
      <p className="fees-subtitle">
        Full transparency. Here's how costs work on the platform.
      </p>

      <div className="fees-section">
        <h3>Upload cost</h3>
        <p>
          When you upload a video, a one-time cost is charged that covers the first <strong>3 months</strong> of
          storage. This cost is automatically deducted from your platform balance.
        </p>
        <p>
          The cost depends on the duration and quality of the video. There is a minimum to cover operational costs.
        </p>
      </div>

      <div className="fees-section">
        <h3>Monthly storage</h3>
        <p>
          After the initial 3 months, a monthly storage cost based on file size is automatically deducted
          from the video's balance.
        </p>
        <p>
          If the video's balance reaches zero, the video is temporarily <strong>archived</strong>.
          Existing buyers retain access, but new buyers won't be able to access it until
          you top up the balance.
        </p>
      </div>

      <div className="fees-section">
        <h3>Current fees</h3>
        {fees ? (
          <table className="fees-table">
            <thead>
              <tr>
                <th>Concept</th>
                <th>Fee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Storage per GB/month</td>
                <td>{fmt(fees.storageFeePerGB?.formatted)}</td>
              </tr>
              <tr>
                <td>Minimum per upload</td>
                <td>{fmt(fees.uploadFeeMinimum?.formatted)}</td>
              </tr>
              <tr>
                <td>Upload 720p (per hour)</td>
                <td>{fmt(fees.uploadFeePerHour?.['720p']?.formatted)}</td>
              </tr>
              <tr>
                <td>Upload 1080p (per hour)</td>
                <td>{fmt(fees.uploadFeePerHour?.['1080p']?.formatted)}</td>
              </tr>
              <tr>
                <td>Upload 4K (per hour)</td>
                <td>{fmt(fees.uploadFeePerHour?.['4K']?.formatted)}</td>
              </tr>
            </tbody>
          </table>
        ) : (
          <p className="fees-loading">Loading fees...</p>
        )}
      </div>

      <div className="fees-section">
        <h3>Archived video</h3>
        <p>
          If your video is archived due to insufficient balance, simply top up its balance from
          your wallet on the platform. The video reactivates automatically and becomes available
          to new buyers again.
        </p>
      </div>

      <div className="fees-section">
        <h3>Important note</h3>
        <p>
          Fees may change in the future. Existing videos keep their conditions
          until the next billing cycle.
        </p>
      </div>

      <Link to="/upload" className="btn btn-primary fees-back-btn">Back to upload content</Link>
    </div>
  );
}
